import { cva } from "class-variance-authority";

export const badgeVariants = cva(
  "inline-flex items-center justify-center w-fit whitespace-nowrap shrink-0 relative isolate overflow-hidden rounded-2xl border text-center font-medium transition-[color,border-color] focus-visible:outline-hidden focus-visible:ring-inset focus-visible:ring-2 focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
  {
    variants: {
      variant: {
        primary:
          "bg-slate-50 text-brand-700 border-brand-300 [a&]:hover:bg-slate-50/90",
        warning:
          "bg-warning-50 text-warning-700 border-warning-200 [a&]:hover:bg-warning-50/90",
        success:
          "bg-success-50 text-success-700 border-success-200 [a&]:hover:bg-success-50/90",
        info: "bg-info-50 text-info-700 border-info-200 [a&]:hover:bg-info-50/90",
        destructive:
          "bg-error-50 text-error-700 border-error-200 [a&]:hover:bg-error-50/90",
        secondary:
          "bg-brand-25 text-brand-600 border-brand-100 [a&]:hover:bg-brand-100/90",
        default:
          "bg-grey-50 text-slate-700 border-grey-200 [a&]:hover:bg-grey-50/90",
      },

      size: {
        sm: "px-2 py-0.5 text-xs leading-[18px]",
        md: "px-2.5 py-0.5 text-sm leading-5",
        lg: "px-3 py-1 text-sm leading-5",
      },

      shape: {
        pill: "",
        rounded: "",
      },

      hasPrefix: { true: "", false: "" },
      hasSuffix: { true: "", false: "" },
    },

    compoundVariants: [
      { shape: "pill", size: "sm", class: "rounded-2xl" },
      { shape: "pill", size: "md", class: "rounded-2xl" },
      { shape: "pill", size: "lg", class: "rounded-2xl" },

      { shape: "rounded", size: "sm", class: "rounded-md" },
      { shape: "rounded", size: "md", class: "rounded-md" },
      { shape: "rounded", size: "lg", class: "rounded-lg" },

      {
        size: "sm",
        hasPrefix: true,
        hasSuffix: false,
        class: "pl-1.5 pr-2 gap-1",
      },
      {
        size: "md",
        hasPrefix: true,
        hasSuffix: false,
        class: "pl-2 pr-2.5 gap-1.5",
      },
      {
        size: "lg",
        hasPrefix: true,
        hasSuffix: false,
        class: "pl-2.5 pr-3 gap-1.5",
      },

      {
        size: "sm",
        hasPrefix: false,
        hasSuffix: true,
        class: "pl-2 pr-[3px] gap-0.5",
      },
      {
        size: "md",
        hasPrefix: false,
        hasSuffix: true,
        class: "pl-2.5 pr-1 gap-0.5",
      },
      {
        size: "lg",
        hasPrefix: false,
        hasSuffix: true,
        class: "pl-3 pr-1.5 gap-0.5",
      },

      {
        size: "sm",
        hasPrefix: true,
        hasSuffix: true,
        class: "pl-1.5 pr-[3px] gap-1",
      },
      {
        size: "md",
        hasPrefix: true,
        hasSuffix: true,
        class: "pl-2 pr-1 gap-1.5",
      },
      {
        size: "lg",
        hasPrefix: true,
        hasSuffix: true,
        class: "pl-2.5 pr-1.5 gap-1.5",
      },
    ],

    defaultVariants: {
      variant: "default",
      size: "sm",
      shape: "pill",
    },
  },
);
